import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-providers-intro',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './providers-intro.component.html',
  styleUrl: './providers-intro.component.scss'
})
export class ProvidersIntroComponent {

}
